<div [attr.data-testid]="testIds.containerPrivacy">
  <app-settings-slider
    [(modelNg)]="this.settingsOriginator.state.settingsConfigurations.typingNotifications"
    [choiceDescriptor]="this.settingsOriginator.state.settingsConfigurations.typingNotifications ? 'aktiv' : 'inaktiv'"
    settingDescriptor="1. Benachrichtigung"></app-settings-slider>
  <app-settings-slider
    [(modelNg)]="this.settingsOriginator.state.settingsConfigurations.receipts"
    [choiceDescriptor]="this.settingsOriginator.state.settingsConfigurations.receipts ? 'aktiv' : 'inaktiv'"
    settingDescriptor="2. Lesebestätigung"></app-settings-slider>
  <!--- INFO: Noch keine Funktion---->
  <app-settings-slider
    [(modelNg)]="this.settingsOriginator.state.settingsConfigurations.presencePrivacy"
    [choiceDescriptor]="this.settingsOriginator.state.settingsConfigurations.presencePrivacy ? 'aktiv' : 'inaktiv'"
    settingDescriptor="3. Präsenzstatus">
    @if (!this.settingsOriginator.state.settingsConfigurations.presencePrivacy) {
      <span class="presence-info">
        <mat-icon class="info-icon" svgIcon="tooltip-i"></mat-icon>
        <span class="info-text">{{ infoTextPresence }}</span>
      </span>
      <app-tooltip-icon
        class="tooltip"
        [infoText]="infoTextPresence"
        [infoTitle]="'Status anzeigen'"></app-tooltip-icon>
    }
  </app-settings-slider>
  <div class="privacy-container">
    <p class="privacy-descriptor">4. Abmelden nach Inaktivität</p>
    <span class="inactivity-info">
      <mat-icon class="info-icon" svgIcon="tooltip-i"></mat-icon>
      <span class="info-text">{{ infoTextInacitvity }}</span>
    </span>
    <app-tooltip-icon
      class="tooltip-inactivity"
      [infoText]="infoTextInacitvity"
      [infoTitle]="'Zeiteinheit Inaktivität'"></app-tooltip-icon>
    <div class="item-container">
      <input
        type="number"
        class="inactivity-input"
        [(ngModel)]="inactivityInHours"
        [attr.data-testid]="testIds.inputInactivity"
        max="168"
        step="1"
        (keydown)="preventInvalidNumberInput($event)" />
    </div>
  </div>
  @if (settingsOriginator.state.settingsConfigurations.inactivity < conversionFactor) {
    <div class="error">
      <div class="error-message">Die Inaktivität kann nicht weniger als eine Stunde betragen</div>
    </div>
  } @else if (inactivityInHours > maxInactivity) {
    <div class="error">
      <div class="error-message">Die Inaktivität kann nicht mehr als 168 Stunden betragen</div>
    </div>
  }
  <div class="privacy-container">
    <p class="privacy-descriptor">5. Berechtigungsmanagement</p>
    <div class="item-container">
      <mat-icon
        (click)="toggleDropdown()"
        (keydown.enter)="toggleDropdown()"
        [class.open]="berechtigungsmanagementVisible"
        class="arrow-icon"
        [attr.data-testid]="testIds.permissionArrowDown"
        svgIcon="arrow-down"
        tabindex="0"></mat-icon>
    </div>
  </div>

  @if (berechtigungsmanagementVisible) {
    <div class="privacy-container">
      <p>Wer darf mich kontaktieren?</p>
      <div class="item-container">
        <mat-icon
          [class.selected]="selected === AuthMode.ALLOW_ALL || authMode === AuthMode.ALLOW_ALL"
          class="user-icon"
          (click)="select(AuthMode.ALLOW_ALL)"
          (keydown.enter)="select(AuthMode.ALLOW_ALL)"
          svgIcon="user"
          [attr.data-testid]="testIds.permissionAllowallIcon"
          tabindex="0" />
        <mat-icon
          svgIcon="user"
          [class.selected]="selected === AuthMode.BLOCK_ALL || authMode === AuthMode.BLOCK_ALL"
          class="user-icon block-all"
          (click)="select(AuthMode.BLOCK_ALL)"
          (keydown.enter)="select(AuthMode.BLOCK_ALL)"
          [attr.data-testid]="testIds.permissionBlockallIcon"
          tabindex="0" />
      </div>
    </div>
    <mat-tab-group class="members-tab-group" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="User">
        <table
          #userTable
          [dataSource]="modifyDatasourceForPage(users)"
          class="mat-elevation-z0 members-table"
          mat-table>
          <!-- Avatar Column -->
          <ng-container matColumnDef="avatar">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-avatar" mat-cell>
              <mat-icon class="avatar-image" mat-card-avatar svgIcon="default-user-icon"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="timAdress">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" mat-cell>TIM-Adresse: {{ element }}</td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-kick" mat-cell>
              <mat-icon
                (click)="deleteItemFromUserList(element)"
                svgIcon="user-minus"
                [attr.data-testid]="'icon_kick_member_' + element"
                class="kick-icon"
                matTooltip="Personen entfernen"
                (keydown)="$event.stopPropagation()"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="addBtn">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <app-button
                (clicked)="matDialog.open(dialog)"
                id="button_inviteuser"
                [dataTestId]="testIds.buttonInviteuser"
                onKeyUp="dialogService.open(dialog)"
                text="Weitere Personen"
                tooltip="Fügen Sie der Liste weitere Personen hinzu"
                [customWidth]="'100%'"
                tooltipPosition="left">
                <mat-icon class="add-icon" svgIcon="plus-icon"></mat-icon>
              </app-button>
            </td>
          </ng-container>
          <ng-container matColumnDef="paginator">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <mat-paginator
                #userPaginator
                [length]="users.length"
                [pageSize]="pageSize"
                [pageSizeOptions]="[]"
                [hidePageSize]="true"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
                [attr.data-testid]="testIds.userPaginator">
              </mat-paginator>
            </td>
          </ng-container>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          <tr *matFooterRowDef="['addBtn']" mat-footer-row></tr>
          <tr *matFooterRowDef="['paginator']" mat-footer-row></tr>
        </table>
      </mat-tab>
      <mat-tab label="Gruppe" [attr.data-testid]="testIds.permissionTabGroups">
        <table
          #groupTable
          [dataSource]="modifyDatasourceForPage(groups)"
          class="mat-elevation-z0 members-table"
          mat-table>
          <ng-container matColumnDef="avatar">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-avatar" mat-cell>
              <mat-icon class="avatar-image" mat-card-avatar svgIcon="group"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="timAdress">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" mat-cell>{{ isInsuredPersonMap[element] }}</td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-kick" mat-cell>
              <mat-icon
                (click)="deleteItemFromGroupList(element)"
                svgIcon="user-minus"
                [attr.data-testid]="testIds.iconKickMember"
                class="kick-icon"
                matTooltip="Gruppe entfernen"
                (keydown)="$event.stopPropagation()"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="addBtn">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <app-button
                (clicked)="matDialog.open(dialog)"
                [dataTestId]="testIds.buttonInvitegroup"
                onKeyUp="dialogService.open(dialog)"
                text="Weitere Gruppen"
                tooltip="Fügen Sie der Liste weitere Gruppen hinzu"
                customWidth="100%"
                tooltipPosition="left">
                <mat-icon svgIcon="plus-icon"></mat-icon>
              </app-button>
            </td>
          </ng-container>
          <ng-container matColumnDef="paginator">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <mat-paginator
                #groupPaginator
                [length]="groups.length"
                [pageSize]="pageSize"
                [pageSizeOptions]="[]"
                [hidePageSize]="true"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
                [attr.data-testid]="testIds.groupPaginator">
              </mat-paginator>
            </td>
          </ng-container>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          <tr *matFooterRowDef="['addBtn']" mat-footer-row></tr>
          <tr *matFooterRowDef="['paginator']" mat-footer-row></tr>
        </table>
      </mat-tab>
      <mat-tab label="Server" [attr.data-testid]="testIds.permissionTabServers">
        <table
          #serverTable
          [dataSource]="modifyDatasourceForPage(servers)"
          class="mat-elevation-z0 members-table"
          mat-table>
          <ng-container matColumnDef="avatar">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-avatar" mat-cell>
              <mat-icon class="avatar-image" mat-card-avatar svgIcon="globe"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="timAdress">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" mat-cell>TIM-Adresse: {{ element }}</td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let element" class="col-kick" mat-cell>
              <mat-icon
                (click)="deleteItemFromServerList(element)"
                svgIcon="user-minus"
                [attr.data-testid]="testIds.iconKickMember"
                class="kick-icon"
                matTooltip="Server entfernen"
                (keydown)="$event.stopPropagation()"></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="addBtn">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <app-button
                (clicked)="matDialog.open(dialog)"
                [dataTestId]="testIds.buttonInviteserver"
                onKeyUp="dialogService.open(dialog)"
                text="Weitere Server"
                tooltip="Fügen Sie der Liste weitere Server hinzu"
                customWidth="100%"
                tooltipPosition="left">
                <mat-icon svgIcon="plus-icon"></mat-icon>
              </app-button>
            </td>
          </ng-container>
          <ng-container matColumnDef="paginator">
            <td *matFooterCellDef colspan="4" mat-footer-cell>
              <mat-paginator
                #serverPaginator
                [length]="servers.length"
                [pageSize]="pageSize"
                [pageSizeOptions]="[]"
                [hidePageSize]="true"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
                [attr.data-testid]="testIds.serverPaginator">
              </mat-paginator>
            </td>
          </ng-container>
          <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          <tr *matFooterRowDef="['addBtn']" mat-footer-row></tr>
          <tr *matFooterRowDef="['paginator']" mat-footer-row></tr>
        </table>
      </mat-tab>
    </mat-tab-group>
  }

  <div class="privacy-container">
    <app-button
      [isPrimary]="true"
      [dataTestId]="testIds.privacyButtonSave"
      class="submit-btn"
      text="Speichern"
      (click)="saveSettings()"
      [isDisabled]="
        settingsOriginator.state.settingsConfigurations.inactivity < conversionFactor ||
        inactivityInHours > maxInactivity
      "
      (keydown)="$event.stopPropagation()"
      type="submit"></app-button>
  </div>
</div>

<ng-template #dialog>
  <div class="header-container">
    <h1 class="header">
      {{ selected === AuthMode.ALLOW_ALL ? 'Blockliste' : 'Freigabeliste' }}
    </h1>
    @switch (title()) {
      @case ('User') {
        <h2 class="sub-header">
          Bitte geben Sie die MXID des Users ein, den Sie
          {{ selected === AuthMode.ALLOW_ALL ? 'blockieren' : 'freigeben' }}
          möchten.
        </h2>
      }
      @case ('Gruppe') {
        <h2 class="sub-header">
          Bitte geben Sie die Gruppenbezeichnung der Gruppe ein, die Sie
          {{ selected === AuthMode.ALLOW_ALL ? 'blockieren' : 'freigeben' }} möchten.
        </h2>
      }
      @case ('Server') {
        <h2 class="sub-header">
          Bitte geben Sie die Domain des Servers ein, den Sie
          {{ selected === AuthMode.ALLOW_ALL ? 'blockieren' : 'freigeben' }}
          möchten.
        </h2>
      }
    }
  </div>
  <h1 class="blocklist-name">
    {{ selected === AuthMode.ALLOW_ALL ? 'Blockliste' : 'Freigabeliste' }}
    {{ title() }}
  </h1>

  @if (title() === 'Gruppe') {
    <form [formGroup]="activeForm">
      <mat-form-field class="group-select">
        <mat-select [attr.data-testid]="testIds.groupSelect" placeholder="Gruppe" [formControlName]="'name'">
          <mat-option [attr.data-testid]="testIds.groupSelectOption" value="isInsuredPerson"> Versicherte</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  } @else {
    <app-searchbar
      (keydown.enter)="addEntry(title(), activeForm.value.name)"
      [controlName]="'name'"
      [dataTestId]="'field_search_input'"
      [formDataTestId]="'field_search'"
      [groupOfForm]="activeForm"
      class="searchbar">
      @if (activeForm.get('name')?.errors && activeForm.get('name')?.dirty) {
        <div class="error-message">
          @if (activeForm.get('name')?.errors?.['required']) {
            Bitte geben Sie eine {{ title() === 'User' ? 'Matrix-Id' : 'Server' }} an
          }
          @if (activeForm.get('name')?.errors?.['pattern'] && title() === 'User') {
            Matrix-Id entspricht nicht dem gültigen Format: "&#64;[Benutzer-Id]:[Server-Adresse]"
          }
          @if (activeForm.get('name')?.errors?.['pattern'] && title() === 'Server') {
            Server entspricht nicht dem gültigen Format: "[Bsp: matrix.de]"
          }
        </div>
      }
    </app-searchbar>
  }
  <div class="button-container">
    <app-button (clicked)="resetForm()" [dataTestId]="'button_cancel'" text="Abbrechen"></app-button>
    <app-button
      (clicked)="addEntry(title(), activeForm.value.name)"
      [dataTestId]="'button_invite'"
      [isDisabled]="!activeForm.valid && activeForm.invalid"
      [isPrimary]="true"
      text="Teilnehmer hinzufügen"></app-button>
  </div>
</ng-template>
